import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/auth/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
export class AppComponent implements OnInit {
  constructor(private readonly authService: AuthService) {}

  ngOnInit(): void {
    // Vérifier l'état d'authentification au chargement de l'application
    // Cela évite un flash visuel de la page de login si l'utilisateur est déjà connecté
    // Le guard guestGuard gérera la redirection si nécessaire
    this.authService.checkAuthState();
  }
}
